const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');

module.exports = withRenderedMain(withCachedSelectors(BaseView.extend({
    promoBadgeInitialized: false,
    childContainerInitialized: false,
    childLayerOpenedClass: 'open',
    childContainerTitleClass: 'odf-text-xl',
    selectors: {
        childComponentContainer: '.child_component',
        boxContainer: '.ancillaries_box_container',
        childContainer: '.ancillaries_child_container',
        childContainerHeaderTitle: '.ancillaries_child_container_header_title',
        childContainerFooter: '.ancillaries_child_container_footer',
        ancillariesChildLayerWrapper: '.ancillaries_child_wrapper',
        promoBadgeWrapper: '.promo_badge_wrapper',
        feeTooltipHint: '.fee_bags_tooltip_hint',
    },
    events: {
        'tap .ancillaries_open_child': 'onOpen',
        'tap .ancillaries_more_info': 'onClickMoreInfo',
        'tap .ancillaries_btn_back': 'onClose',
        'tap .ancillaries_btn_confirm': 'onConfirm',
        'tap .product_info': 'onProductInfo',
    },

    initialize() {
        const childComponentFactory = this.options.child;
        const childComponentFactoryOptions = this.options.childOptions || {};
        this.render();
        this.initializeChildComponent(childComponentFactory, childComponentFactoryOptions);
        this.bindEvents();
    },

    bindEvents() {
        this.listenTo(this.model, `change:${this.model.getProductProperty()}`, this.onDataUpdated);
        this.listenTo(this.model, `change:${this.model.getChildContainerDataProperty()}`, this.updateChildContainer);
    },

    initializeChildComponent(childComponentFactory, childComponentFactoryOptions) {
        this.childComponent = childComponentFactory.create({
            ...childComponentFactoryOptions,
            el: this.$el.find(this.selectors.childComponentContainer).get(0),
            props: {
                updateProduct: this.model.set.bind(this.model, this.model.getProductProperty()),
                updateChildContainerData: this.model.set.bind(this.model, this.model.getChildContainerDataProperty()),
                updateChildContainerFooter: this.updateChildContainerFooter.bind(this),
                onParent: this.on.bind(this),
            },
        });
    },

    render() {
        this.$el.html(this.templates.main());
        this.renderBox();
        this.renderChildContainer();
    },

    onDataUpdated() {
        this.renderBox();

        const data = this.model.getProduct();
        const hideChildContainer = data?.child?.hide;
        this.$el
            .find(this.selectors.ancillariesChildLayerWrapper)
            .toggleClass('odf-hidden', hideChildContainer);


        if (!this.promoBadgeInitialized) {
            this.promoBadgeInitialized = true;
        }
    },

    renderBox() {
        const data = this.model.getProduct();
        let content;
        let template;
        if (data) {
            const templateName = data.template.name;
            template = this.templates[templateName];

            content = data.isSelected
                ? data.parent.selected
                : data.parent.base;

            content.isSelected = data.isSelected;
            content.productAvailable = data.productAvailable;
            content.productAvailableAndNotSelected = data.productAvailable && !data.isSelected;
            content.ctaClass = this.model.getCtaClass();
            content.promoBadge = data.promoBadge;
            content.primePriceFromLabel = data.primePriceFromLabel;
            content.fee = data.fee;
        } else {
            template = this.templates.loading;
        }

        this.$el.find(this.selectors.boxContainer).html(template(content));
    },

    renderChildContainer() {
        const template = this.templates.childContainer;
        this.$el.find(this.selectors.childContainer).html(template({
            prismaHeader: Odigeo.AB.prismaHeader,
        }));
    },

    updateChildContainer() {
        this.track('onLoad');
        this.updateChildContainerTitle();
        this.updateChildContainerFooter();
    },

    updateChildContainerTitle() {
        const data = this.model.getChildContainerData() || {};
        const isSelected = (this.model.getProduct() || {}).isSelected;
        const content = isSelected ? data.child.selected : data.child.base;
        content.fee = this.model.getProduct()?.fee;
        if (content?.title) {
            content.textSizeClass = this.childContainerTitleClass;
            const titleContent = this.templates.childContainerTitle(content);
            this.$el.find(this.selectors.childContainerHeaderTitle).html(titleContent);
        }
    },

    updateChildContainerFooter() {
        const isSelected = (this.model.getProduct() || {}).isSelected;
        const data = this.model.getChildContainerData() || {};
        const content = isSelected ? data.child.selected : data.child.base;

        if (content?.footer) {
            const footerContent = this.templates.childContainerFooter(content);
            this.$el.find(this.selectors.childContainerFooter).html(footerContent);
        }
    },

    onOpen(e) {
        e.preventDefault();
        e.stopPropagation();

        this.track('onOpen');
        this.toggleChildLayer(true);
    },
    onClickMoreInfo() {
        this.model.getProduct()?.child?.custom?.clickMoreInfo();
    },
    onClose(e) {
        e.preventDefault();
        e.stopPropagation();

        this.track('onClose');
        this.toggleChildLayer(false);
    },

    onProductInfo(e) {
        e.preventDefault();
        e.stopPropagation();

        const data = this.model.getProduct();
        const content = data.isSelected
            ? data.parent.selected
            : data.parent.base;

        this.track('onProductInfo');

        if (typeof Odigeo._.get(content, 'productInfo.onClick') === 'function') {
            content.productInfo.onClick();
        }
    },

    toggleChildLayer(show, backWithHistory = true) {
        const data = this.model.getProduct();
        if (data?.child?.custom) {
            data.child.custom.toggleChildLayer(show);
        } else {
            this._toggleChildLayer(show);
        }

        this.trigger('childLayerToggled', show);
    },

    _toggleChildLayer(show) {
        this.$el.find(this.selectors.ancillariesChildLayerWrapper)
            .toggleClass(this.childLayerOpenedClass, show);
    },

    track(event) {
        this.childComponent.get('getTrackingData', event).then((trackingData) => {
            if (trackingData) {
                const {tracking, params} = trackingData;
                tracking[event](params);
            }
        });
    },
})));
